import { Component, Input } from '@angular/core';
import { UntypedFormControl } from '@angular/forms';
import { IS1InputSelectItem } from '@app/s1';
import { TipoPagamento } from '@app/shared/models/assistenza';
import { UtilityService } from '@app/shared/services/utility.service';

@Component({
  selector: 'ser-tipo-pagamento-select',
  templateUrl: './tipo-pagamento-select.component.html',
  styleUrl: './tipo-pagamento-select.component.scss'
})
export class TipoPagamentoSelectComponent {

  @Input() control: UntypedFormControl;
  @Input() label: string = "assistenze.fields.tipoPagamento";
  @Input() readonly: boolean = false;

  tipi: IS1InputSelectItem[];

  constructor(private utils: UtilityService) {
    this.tipi = this.utils.getInputSelectFromEnum(TipoPagamento);
  }

}
